import { Link } from "react-router-dom";
import { MaskLines } from "../components/site/Reveal";

export default function Account() {
  return (
    <div className="bg-ivory pb-24 pt-36 md:pt-44" data-testid="account-page">
      <div className="mx-auto max-w-xl px-5 text-center">
        <p className="label-mono">Account</p>
        <MaskLines as="h1" lines={["Welcome", <em key="b">back.</em>]} className="mt-3 font-display text-5xl font-light leading-[0.95] text-ink md:text-7xl" />
        <p className="mt-6 text-sm leading-relaxed text-graphite">
          Sign-in, order history and saved addresses are provided by Shopify customer accounts in the live store. This prototype does not include accounts.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/track-order" className="btn-dark" data-testid="account-track-button">Track an order</Link>
          <Link to="/contact" className="btn-outline" data-testid="account-contact-button">Contact us</Link>
        </div>
      </div>
    </div>
  );
}
